import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CertificateNote_Interface } from 'src/app/Interface/CertificateNote_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CertificateNoteService {

  constructor(private http: HttpClient) { }


  GetRecord(): Observable<Array<CertificateNote_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/CertificateNote").pipe(
      map(data => {
        return data as Array<CertificateNote_Interface>
      })
    )
  }

  GetActiveList(): Observable<Array<CertificateNote_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/CertificateNote/GetActiveList").pipe(
      map(data => {
        return data as Array<CertificateNote_Interface>
      })
    )
  }



  AddCertificateNote(model: CertificateNote_Interface): Observable<CertificateNote_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id: model.id,
      dsc: model.dsc,
      code: model.code,
      del: false,
      username: '',
      subdate: null
    }


    return this.http.post(environment.BaseUrl + "Daro/CertificateNote/Add", body, { headers }).pipe(
      map(data => {
        return data as CertificateNote_Interface
      })
    )

  }


  DeleteCertificateNote(id: number): Observable<CertificateNote_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/CertificateNote/Delete?id=" + id ).pipe(
      map(data => {
        return data as CertificateNote_Interface
      })
    )

  }


  GetActiveListCertificate(id:number): Observable<Array<CertificateNote_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/CertificateNote/GetActiveListCertificate?id="+id).pipe(
      map(data => {
        return data as Array<CertificateNote_Interface>
      })
    )
  }


  SubmitCertificate(calibration_id:number,id:number):Observable<CertificateNote_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/CertificateNote/SubmitCertificate?calibration_detail_id="+calibration_id
      +"&certificate_id="+id
    ).pipe(
      map(data=>{
        return data as CertificateNote_Interface
      })
    )
  }

  DeleteCertificate(calibration_id:number,id:number):Observable<CertificateNote_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/CertificateNote/DeleteCertificate?calibration_detail_id="+calibration_id
      +"&certificate_id="+id
    ).pipe(
      map(data=>{
        return data as CertificateNote_Interface
      })
    )
  }

}
